import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

/**
 * Regle de fuseau horaire : la base stocke des `timestamptz` (UTC).
 * L'affichage se fait dans le fuseau du marche (Abidjan = UTC+0, pas d'heure d'ete),
 * ce qui rend le sujet simple aujourd'hui, mais la regle est explicite pour le jour
 * ou la plateforme couvrira le Maroc (UTC+1) ou le Cameroun (UTC+1).
 */
export const MARKET_TIME_ZONE = 'Africa/Abidjan';

export function formatDate(value: string | Date): string {
  const date = typeof value === 'string' ? parseISO(value) : value;
  return format(date, 'd MMMM yyyy', { locale: fr });
}

export function formatDateTime(value: string | Date): string {
  const date = typeof value === 'string' ? parseISO(value) : value;
  return format(date, "d MMMM yyyy 'à' HH'h'mm", { locale: fr });
}

export function formatShortDateTime(value: string | Date): string {
  const date = typeof value === 'string' ? parseISO(value) : value;
  return format(date, "d MMM · HH'h'mm", { locale: fr });
}

/** Valeur `YYYY-MM-DD` utilisable dans un <input type="date">. */
export function toDateInputValue(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

/** Combine une date `YYYY-MM-DD` et une heure `HH:mm` en objet Date local. */
export function combineDateAndTime(dateValue: string, timeValue: string): Date {
  return new Date(`${dateValue}T${timeValue.length === 5 ? timeValue : '10:00'}:00`);
}
